module.exports = __webpack_public_path__ + "img/campaign_3.388a180c.png";